if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form)
        this.form.querySelector('[name=id]').disabled = false;
      this.cartType = document.body.getAttribute('data-cart-type'); // drawer || notification || page
      if (this.cartType !== "page" && this.form) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartModal = this.cartType === "notification" ?
          document.querySelector('cart-notification') : document.querySelector('cart-drawer'); // could be cart-notification || cart-drawer
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;
      if (submitButton.classList.contains('prelaunch-product')) return;

      this.handleErrorMessage();
      this.cartModal.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      if (this.querySelector('.loading-overlay__spinner'))
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      let formData;
      if (this.form.matches('[data-bundle-product="true"]')) {
        formData = JSON.stringify(this.buildBundleForm()); // loops through selected variants and build items object { 'items': [{...}, {...}] }
      } else {
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        formData = new FormData(this.form);
        formData.append('sections', this.cartModal.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          
          submitButton.classList.add('success');
          const forceDrawerOpen = true;
          window.dispatchEvent(new CustomEvent('dresslife:cart-change', {
            detail: {
              source: 'product-form',
              cart: response,
            },
          }));
          this.cartModal.renderContents(response, forceDrawerOpen);

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');

          submitButton.removeAttribute('aria-disabled');
          if (this.querySelector('.loading-overlay__spinner'))
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (this.dataset.productHandle) {
            updateWishlist(this.dataset.productHandle, this.dataset.productPrice);
          }
          const parentDrawer = this.closest('quick-view-drawer');
          if (parentDrawer && parentDrawer.closeQuickViewDrawer ) {
            parentDrawer.closeQuickViewDrawer();
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      if(window.showToast && errorMessage) {
        window.showToast(errorMessage, 5000);
        return;
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    buildBundleForm() {
      var bundleItems = document.querySelectorAll('[form="'.concat(this.form.getAttribute('id'), '"].select--bundle.is-active'));
      const bundleQuanity = 1;

      var setID = Date.now().toString().slice(8);
      var formItems = [];
      var bundleItem = {
        'id': parseInt(this.form.getAttribute('data-bundle-variant-id')),
        'quantity': bundleQuanity,
        'properties': {
          'Bundle': setID
        }
      };
      formItems.unshift(bundleItem);

      bundleItems.forEach(function (item, i) {
        var item = {
          'id': parseInt(item.dataset.variantId),
          'quantity': bundleQuanity,
          'properties': {
            'Bundle': setID
          }
        };
        // add items o the begging so it show in the cart in the same order as on the mixmatch widget
        formItems.unshift(item)
      });

      var formData = {
        'items': formItems
      };

      formData.sections = this.cartModal.getSectionsToRender().map((section) => section.id);
      formData.sections_url = window.location.pathname;
      return formData;
    }
  });
}
